var _path, _path2, _path3, _path4, _circle, _circle2, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGarbageDisposal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "garbage-disposal",
    fill: "none",
    viewBox: "0 0 20 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.1157 17.609v12.516c0 0.5523 0.44772 1 1 1h14.09c0.5523 0 1-0.4477 1-1v-12.516",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.3345 5.7021v-3.8271c0-0.55229 0.44772-1 1-1h7.3324c0.5523 0 1 0.44772 1 1v3.8271",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m0.82861 8.9199v7.6889c0 0.5522 0.44772 1 1 1h16.343c0.5523 0 1-0.4478 1-1v-7.3671",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m14.502 5.7022h-8.9377c-0.1518 0-0.30189 0.03433-0.43776 0.10201-1.5229 0.75859-2.491 1.4325-3.5007 2.3483-0.61272 0.55572-0.25943 1.5538 0.56316 1.641 5.7439 0.60861 9.7423 0.56421 15.779-0.03616 0.7919-0.07876 1.1842-1.0207 0.6446-1.6058-0.9322-1.0109-1.8942-1.7359-3.7906-2.3959-0.1026-0.0357-0.2118-0.05355-0.3204-0.05355z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.161,
    cy: 20.827,
    r: 1.109,
    stroke: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.161,
    cy: 25.976,
    r: 1.109,
    stroke: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m7.2651 17.609v10.585c0 0.5523 0.44771 1 1 1h3.7926c0.5523 0 1-0.4477 1-1v-10.585",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarbageDisposal);
export default __webpack_public_path__ + "static/media/garbage-disposal.5ba79764a4000207011d73019ebaa56b.svg";
export { ForwardRef as ReactComponent };